import { TypographyV3 } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

import { useWizardStateContext } from '@/app/[locale]/product/_contexts/WizardStateProvider';

const CartIsFullMessage = () => {
  const { ringCount, hasMaxRingCount } = useWizardStateContext();
  const t = useTranslations();

  return (
    <>
      {hasMaxRingCount && (
        <TypographyV3 className="border-b border-gray-300/50 pb-5 text-base font-medium">
          {t('cart_full_ring_limit', {
            amount: ringCount,
          })}
        </TypographyV3>
      )}
    </>
  );
};

export default CartIsFullMessage;
